// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty-list-placeholder[data-v-05f799e8]{width:300px;margin:40px auto}.empty-list-placeholder .empty-img[data-v-05f799e8]{width:100%}.empty-list-placeholder .text[data-v-05f799e8]{text-align:center;font-size:16px;color:#bbb;font-weight:700}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
